import { registerMember } from './../api/index';
import { useState } from 'react';
import MyModal from "./MyModal";
import Spinner from "./Spinner";
import React from 'react';
import './Form.css';

const Form = (props) => {
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [displayForm, setDisplayForm] = useState(true);
    const [err, setErr] = useState(false);
    const [email, setEmail] = useState("");
    const [dataChecked, setDataChecked] = useState(false);

    const handleClose = () => {
        setErr(false);
        setShowModal(false);
        setIsLoading(false);
        setDisplayForm(false);
    }

    const onEmailChange = (e) => {
        setEmail(e.target.value);
    }

    const onCheckedChange = () => {
        setDataChecked(!dataChecked);
    }

    const handleClickDisplayLegalNoticeModal = () => {
        window.open("basic/mentions-legales", "_blank");
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const email = e.target.email.value;
        const validated = e.target.validated.value;

        const data = {
            email: email,
            brand: 'boursedirect',
            origin: window.location.origin.toString() 
        }

        setErr(false);
        setShowModal(false);
        setIsLoading(true);
        setDisplayForm(true);

        setDataChecked(validated === 'on' ? true : false)
        setEmail(email);

        try {
            const result = await registerMember(data);
            setIsLoading(false)
            if (result.status === 200) {
                setShowModal(true);
                setDisplayForm(false);
            } else {
                setErr(true);
                setShowModal(false);
                setDisplayForm(true);
            }
        } catch (error) {
            setErr(true);
            setShowModal(false);
            setIsLoading(false);
            setDisplayForm(true);
        }
    }

    const getModalSuccessData = () => {
        return {
            title: "Inscription Espace Membre",
            body: "Votre demande d'inscription pour devenir Membre a bien été prise en compte. Pour finaliser votre inscription, rendez-vous dans votre boîte mail."
        }
    }

    const renderForm = (
        <form className="member-subscription-form" method="post" onSubmit={handleSubmit}>
            <input type="email" id="email" name="email" className="member-subscription-input" placeholder="Entrez-votre email" value={email} onChange={onEmailChange} required />
            <div className="wrapper-validated-conditions">
                <input type="checkbox" id="validated" name="validated" checked={dataChecked} onChange={onCheckedChange} required />
                <label>J’ai pris connaissance des informations concernant <a href="#" id="consentLink" className="color-a" onClick={handleClickDisplayLegalNoticeModal}>les traitements de mes données</a> à caractère personnel et de mes droits associés et j’accepte que les informations fournies soient utilisées par Bourse Direct pour me communiquer des informations sur son offre et ses services. Je peux retirer mon consentement à tout moment.</label>
            </div>
            <input type="submit" id="validate" className="btn btn-default" value="Valider" />
        </form>
    )

    return (
        <>
            {isLoading ? <Spinner /> : displayForm ? renderForm : null}
            <MyModal show={showModal} handleClose={handleClose} bodyText={getModalSuccessData().body}  titleText={getModalSuccessData().title}/>
        </>
    )
}

export default Form;
